import { BrandingConfig } from '@app/Services/Branding/types';

export function mapBrandingConfig(brandingConfig: BrandingConfig | undefined) {
	const isBranded = brandingConfig?.type === 'branded';
	const i18nContext = isBranded ? 'wl' : '';
	const title = isBranded ? brandingConfig?.acquirer?.name : 'Zeal';
	const logo = brandingConfig?.theme?.logo;

	return {
		isBranded,
		i18nContext,
		title,
		logo,
	};
}
